var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "18px",
    viewBox: "0 0 27 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A6A9B451-52DF-42E1-A4E8-04CA07BF5303") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0.0175263158,
    width: 27,
    height: 17.9651053,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Registruokit\\u0117s-vizitui",
    transform: "translate(-772.000000, -531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(515.000000, 531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LT_flag-Copy-2",
    transform: "translate(257.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9290707,8.05263158 L18.8267887,8.05263158 C19.0011944,8.05263158 19.1425781,8.19401534 19.1425781,8.36842105 L19.1425781,8.36842105 L19.1425781,8.36842105 L17.6132812,8.36842105 C17.6132812,8.19401534 17.754665,8.05263158 17.9290707,8.05263158 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#0033A0",
    x: 17.6132812,
    y: 8.36842105,
    width: 1.52929687,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6132812,8.68421053 L19.1425781,8.68421053 C19.1425781,8.85861624 19.0011944,9 18.8267887,9 L17.9290707,9 C17.754665,9 17.6132812,8.85861624 17.6132812,8.68421053 L17.6132812,8.68421053 L17.6132812,8.68421053 Z",
    id: "Rectangle-Copy-2",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "uk"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C8102E",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "15.1875 0.0173684211 11.8125 0.0173684211 11.8125 7.31557895 0 7.31557895 0 10.684 11.8125 10.684 11.8125 17.9822105 15.1875 17.9822105 15.1875 10.684 27 10.684 27 7.31557895 15.1875 7.31557895"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.400391, 12.105263)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#012169",
    points: "4.36561523 0.0188421053 10.5996094 3.47547368 10.5996094 0.0188421053"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "0.0343828125 0.0188421053 10.5996094 5.87694737 10.5996094 4.22042105 3.02204883 0.0188421053"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#012169",
    points: "7.78538672 5.87694737 0.0343828125 1.57884211 0.0343828125 5.87694737"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "16.4347734 12.1241053 27 17.9822105 27 16.3256842 19.4224395 12.1241053"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C8102E",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "16.4347734 12.1241053 27 17.9822105 27 16.3256842 19.4224395 12.1241053"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#012169",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 12.105263)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "4.76407617 0.0187368421 0 2.66031579 0 0.0187368421"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.5652266 0.763684211 10.5652266 5.87689474 1.34425195 5.87689474"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C8102E",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "7.57756055 12.1241053 0 16.3256842 0 17.9822105 0 17.9822105 10.5652266 12.1241053"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#012169",
    points: "6.23399414 5.87547368 0 2.41884211 0 5.87547368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0052B4",
    points: "10.5652266 5.87547368 0 0.0173684211 0 1.67389474 7.57756055 5.87547368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#012169",
    points: "2.81422266 0.0173684211 10.5652266 4.31547368 10.5652266 0.0173684211"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "10.5652266 5.87547368 0 0.0173684211 0 1.67389474 7.57756055 5.87547368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D80027",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "10.5652266 5.87547368 0 0.0173684211 0 1.67389474 7.57756055 5.87547368"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#012169",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.400391, 0.000000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5.8355332 5.87557895 10.5996094 3.234 10.5996094 5.87557895"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.0343828125 5.13063158 0.0343828125 0.0174210526 9.25535742 0.0174210526"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C8102E",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "19.4224395 5.87547368 27 1.67389474 27 0.0173684211 27 0.0173684211 16.4347734 5.87547368"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag-en.024c19ae2794fcd5ed0fe4f9628dc3a4.svg";
export { ForwardRef as ReactComponent };